import React from 'react';
import PropTypes from 'prop-types';
import Sources from './Sources';

const getSourceVideo = (encodings, column) => {
  for (let i = 0; i < encodings.length; i++) {
    if (encodings[i].column === column) {
      return encodings[i].url;
    }
  }
};

class Video extends React.Component {
  static propTypes = {
    stepid: PropTypes.number,
    video: PropTypes.object
  };
  render() {
    const { video, stepid } = this.props;
    const renderVideo = video !== null && video !== undefined;
    const videoSrc = renderVideo
      ? getSourceVideo(video.encodings, 'MP4_592')
      : '';
    return renderVideo ? (
      <video
        id={`video_${stepid}_html5_api`}
        poster={video.image.medium}
        preload="auto"
        controls
        src={videoSrc}
      >
        <Sources encodings={video.encodings} />
        <object
          id="flash_fallback_1"
          className="vjs-flash-fallback"
          width="592"
          height="333"
          type="application/x-shockwave-flash"
          data="https://releases.flowplayer.org/swf/flowplayer-3.2.8.swf"
        >
          <param
            name="movie"
            value="https://releases.flowplayer.org/swf/flowplayer-3.2.8.swf"
          />
          <param name="allowfullscreen" value="true" />
          <param
            name="flashvars"
            value={`config={&quot;playlist&quot;:[&quot;https://d17kynu4zpq5hy.cloudfront.net/igi/hotwateruniversity/lfBvO3axm1Zt1Krb.medium&quot;, {&quot;url&quot;: &quot;${videoSrc}&quot;,&quot;autoPlay&quot;:false,&quot;autoBuffering&quot;:true}]}`}
          />
          <img
            src={video.image.medium}
            width="592"
            height="333"
            alt=""
            title="No video playback capabilities."
          />
        </object>
      </video>
    ) : null;
  }
}

export default Video;



// WEBPACK FOOTER //
// ./src/components/Steps/Video.js